import { For } from "solid-js";
import { t } from "../i18n";

function Instruction(props: { index: number; label: string; data: string | string[] }) {
  return (
    <div class="flex flex-col w-full h-fit gap-1">
      <p class="font-bold">
        <span>{props.index}. </span>
        <span>{props.label}</span>
      </p>
      {typeof props.data === "string" ? (
        props.data
      ) : (
        <For each={props.data}>
          {(item) => {
            return (
              <div class="flex flex-row gap-2 w-full h-full items-center px-4">
                <div class="min-w-16px min-h-16px rounded-full bg-brand" />
                <p>{item}</p>
              </div>
            );
          }}
        </For>
      )}
    </div>
  );
}
export default function () {
  return (
    <section class="flex flex-col w-full h-full gap overflow-auto gap-4">
      <For each={t().terms_and_conditions.instruction}>
        {(item, index) => {
          return <Instruction data={item.data} index={index() + 1} label={item.label} />;
        }}
      </For>
      <span>{t().terms_and_conditions.agree}</span>
    </section>
  );
}
